// Test script for CloudWatch logging functionality
// Run this after authentication to test logging

import logger from './services/logger';

export const testLogging = async () => {
  console.log('Testing CloudWatch logging...');
  
  // Mock user data for testing
  const mockUser = {
    userId: 'test-user-123',
    username: 'test@example.com',
    attributes: {
      email: 'test@example.com'
    }
  };

  try {
    // Test all logging functions
    await logger.logFrontendAuth(mockUser);
    console.log('✓ frontend_auth event logged');

    await logger.logUserLogin(mockUser);
    console.log('✓ user_login event logged');

    await logger.logOAuthCallback(mockUser, 'Google');
    console.log('✓ oauth_callback event logged');

    await logger.logUserLogout(mockUser);
    console.log('✓ user_logout event logged');

    console.log('All logging tests completed successfully!');
    console.log('Check CloudWatch Logs group: /aws/frontend/remote-assistant-site');
  } catch (error) {
    console.error('Logging test failed:', error);
  }
};

// Export for use in browser console
window.testLogging = testLogging;